import { Component } from '@angular/core';
import { SkipUserComponentEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'User Components') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-skipusercomponent-form',
    templateUrl: './skipusercomponent.form.component.html'
})
export class SkipUserComponentFormComponent extends BaseFormComponent {
    public record!: SkipUserComponentEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'userComponentVersions', sectionName: 'User Component Versions', isExpanded: false }
        ]);
    }
}

